import React, { useState } from "react";
import close from "../../Pages/MyProfile/assets/close.png";
import ReactDatePicker from "react-datepicker";
import CurrencySelection from "../../Pages/MyProfile/CurrencySelection/CurrencySelection";
import cradit from "./assets/cradit.png";
import { useBalance, useAccount } from "wagmi";
import "../../Pages/MyProfile/ChooseTypeSale/ChooseTypeSale.css";
import Spinbox from "../../Pages/MyProfile/SpinBox/SpinBox";
import NumericInput from "react-numeric-input";
import Countdown from "../CountDown/CountDown";

const formatDate = (date) => {
  if (date) {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }
  return "";
};
const ListModal = ({ open, setOpen, thum, icon1, icon2, gold }) => {
  const [buttonText, setButtonText] = useState("ETH");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [inputDays, setInputDays] = useState(1); // Assuming you have the inputDays state for the NumericInput
  const [selectedTime, setSelectedTime] = useState(new Date());
  const [fixed, setFixed] = useState(false);
  const [timed, setTimed] = useState(false);
  const { address } = useAccount();
  const { data, isError, isLoading } = useBalance({
    address: address,
  });
  const minSelectableDate = new Date();
  minSelectableDate.setDate(minSelectableDate.getDate()); // Add 1 day to the current date

  const maxSelectableDate = new Date();
  maxSelectableDate.setDate(maxSelectableDate.getDate() + 89); // Add 30 days to the current date
  console.log(data);
  const handleTimeChange = (time) => {
    setSelectedTime(time);
  };
  const [value, onChange] = useState("10:00");
  const handleWrapClick = (e) => {
    e.stopPropagation();
    setOpen(false);
  };
  const handleETH = () => {
    if (buttonText === "ETH") {
      setButtonText("USDT");
    } else if (buttonText === "USDT") {
      setButtonText("ETH");
    }
  };
  const handleInputDaysChange = (value) => {
    setInputDays(value);
    const newDate = new Date();
    newDate.setDate(newDate.getDate() + value);
    setSelectedDate(newDate);
  };
  const handleDatePickerChange = (date) => {
    setSelectedDate(date);
    const currentDate = new Date();
    const differenceInDays = Math.ceil((date - currentDate) / (1000 * 60 * 60 * 24));
    setInputDays(differenceInDays);
  };

  return (
    <>
      <div
        onClick={handleWrapClick}
        style={{scrollbarWidth: "none",}}
        className="fixed z-20   max-h-screen   overflow-y-scroll  removeScroll top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 flex justify-center items-start "
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className="bg-main-black w-[350px] md:w-[481px] h-max  mt-[60px] md:mt-[100px] rounded-[20px]"
        >
          {/* header */}
          <div className="flex justify-between items-center pt-[31px] pl-[10px] md:pl-[36px] pr-[10px] md:pr-[24px] pb-[20px]">
            <h2 className="text-res-normal font-semibold ">Make an Offer </h2>
            <button
              onClick={() => {
                setOpen(false);
              }}
              style={{
                boxShadow: "0px 0.909091px 1.81818px rgba(165, 163, 174, 0.3)",
              }}
              className="w-[20px] flex justify-center items-center h-[20px] bg-main-green rounded-[2px] "
            >
              <img src={close} alt="close" />
            </button>
          </div>
          <div className="px-[10px] md:pl-[36px] md:pr-[31px]">
            {/* thumbnail area  */}
            <div className=" flex justify-between items-center">
              <div className="flex gap-[10px] items-center">
                <img
                  className="w-[100px] h-[100px] rounded-[10px]"
                  src={thum}
                  alt="thumbnail"
                />
                <div>
                  <h2 className="text-res-xs font-bold leading-[26px] ">
                    R34P{" "}
                    {gold ? (
                      <span className="text-[#FFB800]">Gold</span>
                    ) : (
                      "Platinum"
                    )}{" "}
                  </h2>
                  <h6 className="font-medium text-res-xxs ">
                    {gold ? "Tier 2 NFT" : "Tier 1 NFT"}
                  </h6>
                </div>
              </div>
              <div>
                <h2 className="  text-[12px]">Listing Price</h2>
                <h6 className="font-bold leading-[26px] text-res-xs">
                  4.89 ETH
                </h6>
              </div>
            </div>
            {/* token */}
            <h2 className="text-[#8A8AA0] mt-[20px] text-[13px] leading-[20px]">
              Tokens Vested
            </h2>
            <div className="flex gap-[6px]">
              <img src={icon1} alt="drop" className="w-[40px] h-[40px]" />
              <img src={icon2} alt="coin" className="w-[40px] h-[40px]" />
            </div>
            <hr className="mt-[20px] border-main-green" />          <div className="mt-[20px]">
            <div>
              <h2 className="text-res-sm font-semibold leading-[24px] mb-[15px]">
                Choose a type of sale
              </h2>
              <button
                onClick={() => setFixed(!fixed)}
                className={`text-left w-full flex justify-between items-center pr-[21px]  bg-[#09090A] h-[60px] rounded-[6px] single-chose-wrap ${
                  fixed ? "active" : ""
                }`}
              >
                <div className="pl-[20px] md:pl-[55px] py-[7px]   ">
                  <div>
                    <h4 className="font-semibold mb-[2px] text-res-ls leading-[22px]">
                      Buy Now
                    </h4>
                    <p>The item is listed at the price you set</p>
                  </div>
                </div>
                <div className=" w-[18px] ball h-[18px] rounded-full bg-white"></div>
              </button>
              <button
                onClick={() => setTimed(!timed)}
                className={`text-left w-full flex mt-[10px] justify-between items-center pr-[21px] h-[60px] bg-[#09090A] rounded-[6px] single-chose-wrap ${
                  timed ? "active" : ""
                }`}
              >
                <div className="pl-[20px] md:pl-[55px] py-[7px]   ">
                  <div>
                    <h4 className="font-semibold mb-[2px] text-res-ls leading-[22px]">
                      Timed Auction
                    </h4>
                    <p>The item is listed for auction</p>
                  </div>
                </div>
                <div className=" w-[18px] ball h-[18px] rounded-full bg-white"></div>
              </button>
            </div>
          </div>
            {/* chose ara */}
          <div>
             {fixed &&  <div
                style={{ position: "relative" }}
                className="flex h-[48px] bg-[#09090A] border border-main-green rounded-[6px] overflow-hidden text-res-ls mt-[20px]"
              >
                <input
                  className="placeholder:text-white/60  flex-grow bg-transparent active:border-0 focus:border-0 focus:outline-none   px-[16px]  border-r-0"
                  type="number "
                  placeholder="BuyNow Price"
                />
                <CurrencySelection
                  options={["ETH", "ARB", "R34P", "USDT", "DAI", "WBTC"]}
                  defaultValue={"ETH"}
                ></CurrencySelection>
                {/*<button
                  onClick={handleETH}
                  className="border-l w-[65px] border-main-green bg-transparent   text-white font-semibold   rounded-r"
                >
                  {buttonText}
                    </button>*/}
              </div>}
              
          {timed && <div
                style={{ position: "relative" }}
                className="flex h-[48px] bg-[#09090A] border border-main-green rounded-[6px] overflow-hidden text-res-ls mt-[20px]"
              >
                <input
                  className="placeholder:text-white/60  flex-grow bg-transparent active:border-0 focus:border-0 focus:outline-none   px-[16px]  border-r-0"
                  type="number "
                  placeholder="Floor Price"
                />
                {
                  fixed?<button
                  className="border-l w-[65px] border-main-green bg-transparent   text-white font-semibold   rounded-r"
                >
                  ETH
                    </button>:<CurrencySelection
                    options={["ETH", "ARB", "R34P", "USDT", "DAI", "WBTC"]}
                    defaultValue={"ETH"}
                  ></CurrencySelection>
                }
                {/*<button
                  onClick={handleETH}
                  className="border-l w-[65px] border-main-green bg-transparent   text-white font-semibold   rounded-r"
                >
                  {buttonText}
                    </button>*/}
              </div>}
              
          {timed && <div
                style={{ position: "relative" }}
                className="flex h-[48px] bg-[#09090A] border border-main-green rounded-[6px] overflow-hidden text-res-ls mt-[20px]"
              >
                <input
                  className="placeholder:text-white/60  flex-grow bg-transparent active:border-0 focus:border-0 focus:outline-none   px-[16px]  border-r-0"
                  type="number "
                  placeholder="Starting Price"
                />
                <button
                  className="border-l w-[65px] border-main-green bg-transparent   text-white font-semibold   rounded-r"
                >
                  ETH
                    </button>
                {/*<button
                  onClick={handleETH}
                  className="border-l w-[65px] border-main-green bg-transparent   text-white font-semibold   rounded-r"
                >
                  {buttonText}
                    </button>*/}
              </div>}
              <div>
          {timed && <div>
            <div>
              <h2 className="text-res-sm leading-[24px] font-semibold mt-[30px] mb-[15px]">
                Duration
              </h2>
              <div className="flex md:flex-row flex-col justify-between gap-[25px]">
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <NumericInput
                    onChange={handleInputDaysChange}
                    className="bg-[#09090A] rounded-[6px] spinbox-font h-[38px] w-[60px]"
                    style={{ color: "white" }}
                    min={1}
                    max={90}
                    value={inputDays}
                  />
                  <p
                    className="spinbox-font"
                    style={{
                      marginTop: "auto",
                      marginBottom: "auto",
                      marginLeft: "5px",
                      marginRight: "auto",
                    }}
                  >
                    days
                  </p>
                </div>
                <div className="bg-[#09090A] rounded-[6px] flex">
                    <ReactDatePicker
                      selected={selectedDate}
                      onChange={handleDatePickerChange}
                      dateFormat="MMMM d, yyyy"
                      placeholderText="Select a date"
                      value={formatDate(selectedDate)}
                      className="bg-transparent focus:outline-none w-[168px] px-[16px] h-[38px] text-res-ls font-semibold text-white"
                      minDate={minSelectableDate}
                      maxDate={maxSelectableDate}
                    ></ReactDatePicker>
                    <ReactDatePicker
                      selected={selectedTime}
                      onChange={handleTimeChange}
                      showTimeSelect
                      showTimeSelectOnly
                      timeIntervals={1}
                      className="bg-transparent focus:outline-none text-res-ls font-semibold w-[105px] h-[38px] px-[16px]"
                      timeCaption="Time"
                      dateFormat="h:mm aa"
                      placeholderText="Select a time"
                  />
                </div>
              </div>
            </div>
          </div>}
                <div className="mt-[52px] pb-[52px]">
                  <button className="bg-main-green text-[#0E0E0E] font-bold text-res-xs h-[40px] w-full rounded-[6px]">
                    LIST
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div onClick={() => setOpen(false)} className="fixed inset-0  z-10"></div>
    </>
  );
};

export default ListModal;
